"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.organTransplantationMessages = exports.hasOrganTransplantationMessages = exports.OrganTransplantation = exports.HasOrganTransplantation = void 0;
const schema_1 = require("../../../../../schema");
var HasOrganTransplantation;
(function (HasOrganTransplantation) {
    HasOrganTransplantation["HAS_COMBINED_ORGAN_TRANSPLANTATION"] = "has_combined_organ_transplantation";
    HasOrganTransplantation["NO_COMBINED_ORGAN_TRANSPLANTATION"] = "no_combined_organ_transplantation";
})(HasOrganTransplantation || (exports.HasOrganTransplantation = HasOrganTransplantation = {}));
var OrganTransplantation;
(function (OrganTransplantation) {
    OrganTransplantation["HEART"] = "HEART";
    OrganTransplantation["LUNG"] = "LUNG";
    OrganTransplantation["LIVER"] = "LIVER";
    OrganTransplantation["PANCREAS"] = "PANCREAS";
    OrganTransplantation["BONE_MARROW"] = "BONE_MARROW";
})(OrganTransplantation || (exports.OrganTransplantation = OrganTransplantation = {}));
exports.hasOrganTransplantationMessages = {
    [HasOrganTransplantation.HAS_COMBINED_ORGAN_TRANSPLANTATION]: {
        id: "ktx.basicRegistrationData.clinicalData.preImmunisation.combinedOrganTransplantation.hasOrganTransplantation.HAS_COMBINED_ORGAN_TRANSPLANTATION",
        defaultMessage: "Javasolt"
    },
    [HasOrganTransplantation.NO_COMBINED_ORGAN_TRANSPLANTATION]: {
        id: "ktx.basicRegistrationData.clinicalData.preImmunisation.combinedOrganTransplantation.hasOrganTransplantation.NO_COMBINED_ORGAN_TRANSPLANTATION",
        defaultMessage: "Nem javasolt"
    }
};
exports.organTransplantationMessages = {
    [OrganTransplantation.HEART]: {
        id: "ktx.basicRegistrationData.clinicalData.preImmunisation.combinedOrganTransplantation.organTransplantation.HEART",
        defaultMessage: "Szív"
    },
    [OrganTransplantation.LUNG]: {
        id: "ktx.basicRegistrationData.clinicalData.preImmunisation.combinedOrganTransplantation.organTransplantation.LUNG",
        defaultMessage: "Tüdő"
    },
    [OrganTransplantation.LIVER]: {
        id: "ktx.basicRegistrationData.clinicalData.preImmunisation.combinedOrganTransplantation.organTransplantation.LIVER",
        defaultMessage: "Máj"
    },
    [OrganTransplantation.PANCREAS]: {
        id: "ktx.basicRegistrationData.clinicalData.preImmunisation.combinedOrganTransplantation.organTransplantation.PANCREAS",
        defaultMessage: "Pancreas"
    },
    [OrganTransplantation.BONE_MARROW]: {
        id: "ktx.basicRegistrationData.clinicalData.preImmunisation.combinedOrganTransplantation.organTransplantation.BONE_MARROW",
        defaultMessage: "Csontvelő"
    }
};
const hasOrganTransplantation = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(HasOrganTransplantation.HAS_COMBINED_ORGAN_TRANSPLANTATION),
    schema_1.Schema.singleChoiceItem(HasOrganTransplantation.NO_COMBINED_ORGAN_TRANSPLANTATION)
]);
const organTransplantation = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../hasOrganTransplantation} === "has_combined_organ_transplantation"`), schema_1.Schema.multiChoice([
    schema_1.Schema.multiChoiceItem(OrganTransplantation.HEART),
    schema_1.Schema.multiChoiceItem(OrganTransplantation.LUNG),
    schema_1.Schema.multiChoiceItem(OrganTransplantation.LIVER),
    schema_1.Schema.multiChoiceItem(OrganTransplantation.PANCREAS),
    schema_1.Schema.multiChoiceItem(OrganTransplantation.BONE_MARROW)
]));
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ hasOrganTransplantation, organTransplantation })
    .interpretation({ vocab: "ktx", code: "combined_organ_transplantation" });
